import {
	beforeInitializeFacetFiltersForm,
	FacetFiltersForm,
	FacetRemove,
	FacetToggle,
	PriceRange,
} from '@/scripts/content/facets'
import { safeDefineElement } from '@/scripts/functions'
import { initShopify, uCoastWindow } from '@/scripts/setup'

declare let window: uCoastWindow

function initialize() {
	// Shopify window stuff
	if (typeof window.Shopify == 'undefined') {
		window.Shopify = initShopify()
	}

	safeDefineElement(
		FacetFiltersForm,
		beforeInitializeFacetFiltersForm,
		FacetFiltersForm.setListeners
	)
	// these need to come after facets form init
	safeDefineElement(PriceRange)
	safeDefineElement(FacetRemove)
	safeDefineElement(FacetToggle)
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize)
} else {
	initialize()
}

export const shopify = window.Shopify
